import React, { Fragment } from 'react';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';

const CarouselButton = ({ prev, analyticsKey, onClick }) => {
  const className = `carousel-paddle ${
    prev
      ? 'carousel-paddle--left stat-arrow-prev'
      : 'carousel-paddle--right stat-arrow-next'
  }`;

  return (
    <button className={className} onClick={onClick} data-dtm={analyticsKey}>
      <SvgIcon
        name="scroll-arrow"
        className="carousel-paddle__arrow"
        aria-hidden="true"
      />
      <span className="show-for-sr">
        <Translate
          value={
            prev ? 'byo.page.general.prev.step' : 'byo.page.general.next.step'
          }
        />
      </span>
    </button>
  );
};

const CarouselButtons = ({ isVisible, analyticsKey, onPrev, onNext }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Fragment>
      <CarouselButton prev analyticsKey={analyticsKey} onClick={onPrev} />
      <CarouselButton analyticsKey={analyticsKey} onClick={onNext} />
    </Fragment>
  );
};

export default CarouselButtons;
